export const IdObjectConstants = {
    dataCampaignId: "data-campaign-id",
    dataActionId: "data-action-id",
    dataTouchPointId: "data-touch-point-id"
};
